import _createForOfIteratorHelper from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import { couponBatchList, couponSync } from "@/api/couponConfig.js";
import { store } from "@/store/index";
import { getUserInfoMap, getChannelMap } from "@/utils/dictionary";
import urlencode from "urlencode";
import { toGetSearch } from "@/utils/stringFun";
import infoList from "../../../mixins/infoList";
export default {
  mixins: [infoList],
  props: {
    data: {
      type: Object
    }
  },
  data: function data() {
    return {
      listApi: couponBatchList,
      userInfoList: {},
      channelMap: {}
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUserInfoMap();
            case 2:
              _this.userInfoList = _context.sent;
              _context.next = 5;
              return getChannelMap();
            case 5:
              _this.channelMap = _context.sent;
              _this.pageSize = 10;
              _this.searchInfo.coupon_id = _this.data.coupon_id;
              _context.next = 10;
              return _this.getTableData();
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onGenerateBtn: function onGenerateBtn() {
      this.$emit("generate");
    },
    exportCoupon: function exportCoupon(id) {
      var url = '/api/xcpOpsManager/coupon/export?';
      var token = urlencode.encode(store.getters["user/token"], "GBK");
      var obj = {
        token: token,
        id: id
      };
      url += toGetSearch(obj);
      window.open(url, "_blank");
    },
    refresh: function refresh() {
      this.init();
    },
    onSyncBtn: function onSyncBtn(data) {
      var _this2 = this;
      var channelAry = [];
      var channelStr = data.channel.trim();
      if (channelStr) {
        channelAry = channelStr.split(',');
      }
      couponSync({
        'coupon_id': data.coupon_id,
        'batch': data.batch,
        'channel': channelAry
      }).then(function (result) {
        if (result.code == 0) {
          _this2.$message.success('同步成功');
          _this2.getTableData();
        }
      });
    },
    getChannelDisplay: function getChannelDisplay(channel) {
      channel = channel.trim();
      if (channel) {
        var ary = [];
        var _iterator = _createForOfIteratorHelper(channel.split(',')),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var x = _step.value;
            var channelName = this.channelMap[x];
            if (!channelName) {
              channelName = "\u672A\u77E5\u6E20\u9053".concat(x);
            }
            ary.push(channelName);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return ary.join('，');
      } else {
        return '全渠道';
      }
    }
  }
};